import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './emptyState.less';

export function EmptyState({
    icon,
    title,
    description,
    action,
    className,
    size = 'md',
    dataWdio
}) {
    const rootClassName = classNames('vs-empty-state', `is-size-${size}`, className);

    return (
        <div className={rootClassName} role="status" data-wdio={dataWdio}>
            {icon && <div className="vs-empty-state__icon">{icon}</div>}
            {title && <h3 className="vs-empty-state__title">{title}</h3>}
            {description && (
                <p className="vs-empty-state__description">{description}</p>
            )}
            {action && <div className="vs-empty-state__action">{action}</div>}
        </div>
    );
}

EmptyState.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.node,
    description: PropTypes.node,
    action: PropTypes.node,
    className: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    dataWdio: PropTypes.string
};

EmptyState.defaultProps = {
    dataWdio: undefined
};
